// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2Q1TE","buttons":"PendingPaymentAlert_buttons__Z2csi"};